var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "talent-pool-container" },
    [
      _c("div", [
        _vm.loading
          ? _c("div", { staticClass: "background" }, [
              _vm.loading
                ? _c("div", { staticClass: "text-center lds-circle" }, [
                    _vm._m(0),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      !_vm.loading
        ? _c("md-card", [
            _c(
              "div",
              { staticClass: "container talentPool" },
              [
                _c(
                  "div",
                  { staticClass: "talentPoolActions" },
                  [
                    _c(
                      "md-field",
                      { staticStyle: { "max-width": "500px" } },
                      [
                        _c("md-input", {
                          staticClass: "mb-3",
                          attrs: {
                            type: "search",
                            clearable: "",
                            placeholder: "Search records",
                          },
                          model: {
                            value: _vm.search,
                            callback: function ($$v) {
                              _vm.search = $$v
                            },
                            expression: "search",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-success btn-talent-pool",
                        staticStyle: { width: "150px" },
                        on: { click: _vm.toggleFilterMenu },
                      },
                      [_vm._v(" Filter")]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "talentPoolActions" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.selected.length) + " student(s) selected"
                    ),
                  ]),
                  _vm.errorMessage !== ""
                    ? _c("div", [
                        !_vm.selected.length
                          ? _c("p", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(_vm.errorMessage)),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "talentPoolActions" },
                    [
                      _vm.selected.length
                        ? _c(
                            "md-button",
                            {
                              staticClass: "md-danger btn-talent-pool",
                              staticStyle: {
                                width: "10px",
                                "margin-right": "10px",
                              },
                              on: { click: _vm.clearSelectedList },
                            },
                            [_vm._v(" Clear")]
                          )
                        : _vm._e(),
                      _c(
                        "md-button",
                        {
                          staticClass: "jb-standard btn-talent-pool",
                          staticStyle: { width: "150px" },
                          on: { click: _vm.inviteToInterview },
                        },
                        [_vm._v(" Invite to Apply")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "md-table",
                  {
                    attrs: { "md-card": "", id: "content" },
                    on: { "md-selected": _vm.onSelect },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "md-table-row",
                          fn: function (ref) {
                            var item = ref.item
                            return _c(
                              "md-table-row",
                              { attrs: { "md-selectable": "multiple" } },
                              [
                                _c(
                                  "md-table-cell",
                                  {
                                    attrs: {
                                      "md-label": "Name",
                                      "md-sort-by": "name",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                                _c(
                                  "md-table-cell",
                                  {
                                    attrs: {
                                      "md-label": "Surname",
                                      "md-sort-by": "surname",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.surname))]
                                ),
                                _c(
                                  "md-table-cell",
                                  {
                                    attrs: {
                                      "md-label": "Career Track",
                                      "md-sort-by": "careerTrack",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item.careerTrack) + " ")]
                                ),
                                _c(
                                  "md-table-cell",
                                  {
                                    staticStyle: { "max-width": "200px" },
                                    attrs: {
                                      "md-label": "Email",
                                      "md-sort-by": "email",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.email))]
                                ),
                                _c(
                                  "md-table-cell",
                                  {
                                    staticStyle: { "max-width": "60px" },
                                    attrs: {
                                      "md-label": "Status",
                                      "md-sort-by": "status",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.status))]
                                ),
                                _c(
                                  "md-table-cell",
                                  { staticStyle: { "max-width": "200px" } },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-success btn-talent-pool",
                                        staticStyle: { width: "100px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewStudentinTalentPool(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" View Student")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "md-table-cell",
                                  { staticStyle: { "max-width": "200px" } },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "jb-standard btn-talent-pool",
                                        staticStyle: { width: "120px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.inviteStudent(item)
                                          },
                                        },
                                      },
                                      [_vm._v("Invite to apply")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.auth
                                  ? _c("md-table-cell", [
                                      _c(
                                        "div",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.setFavourite(item)
                                            },
                                          },
                                        },
                                        [
                                          item.isTalentPoolFavourite
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "md-icon",
                                                    {
                                                      staticStyle: {
                                                        color: "#e2c800",
                                                      },
                                                    },
                                                    [_vm._v("star")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("star_border"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      2051461727
                    ),
                    model: {
                      value: _vm.reactiveList,
                      callback: function ($$v) {
                        _vm.reactiveList = $$v
                      },
                      expression: "reactiveList",
                    },
                  },
                  [
                    _c("md-table-toolbar", [
                      _c("h1", { staticClass: "md-title" }, [
                        _vm._v(
                          "Students in " +
                            _vm._s(_vm.currentTalentPool.name) +
                            " Talent Pool"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.profileModalVisible
        ? _c(
            "modal",
            { attrs: { size: "xl" }, on: { close: _vm.profileModalHide } },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass:
                        "md-simple md-just-icon md-round modal-default-button",
                      on: { click: _vm.profileModalHide },
                    },
                    [_c("md-icon", [_vm._v("clear")])],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "body" }, [
                _c(
                  "div",
                  { staticStyle: { "z-index": "999" } },
                  [
                    _c("CandidateProfile", {
                      attrs: {
                        userProfile: _vm.currentProfile,
                        showFavoriteButton: true,
                        isTalentPool: _vm.isTalentPool,
                        currentTalentPool: _vm.currentTalentPool,
                        showStatus: "talent pool",
                      },
                      on: { setProfileFavourite: _vm.setProfileFavourite },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.isFilterClicked
        ? _c("StudentFilter", {
            attrs: {
              isFilterClicked: _vm.isFilterClicked,
              uniqueInstitutions: _vm.uniqueInstitutions,
              uniqueQualificationTypes: _vm.uniqueQualificationTypes,
              uniqueYearOfStudy: _vm.uniqueYearOfStudy,
              uniqueDegrees: _vm.uniqueDegrees,
              uniqueInterestedDepartments: _vm.uniqueInterestedDepartments,
              uniquePreferredEmployers: _vm.uniquePreferredEmployers,
              uniqueProgrammes: _vm.uniqueProgrammes,
              uniqueRaces: _vm.uniqueRaces,
              uniqueGenders: _vm.uniqueGenders,
              uniqueDriversLicense: _vm.uniqueDriversLicense,
              uniqueVehicles: _vm.uniqueVehicles,
              uniqueDisability: _vm.uniqueDisability,
              uniqueCitizenships: _vm.uniqueCitizenships,
              uniqueLocations: _vm.uniqueLocations,
              students: _vm.currentTalentPoolStudentTalentPool || [],
              uniqueCareerTracks: _vm.uniqueCareerTracks,
              selectedCareerTracks: _vm.selectedCareerTracks,
            },
            on: {
              "update:isClosed": _vm.handleFilterClose,
              filterChanged: _vm.handleFilterChange,
              "update:selectedCareerTracks": function ($event) {
                _vm.selectedCareerTracks = $event
              },
              "update:selected-career-tracks": function ($event) {
                _vm.selectedCareerTracks = $event
              },
              clearFilters: _vm.clearFilters,
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { "max-width": "250px" } },
        [
          _vm.openInviteModal
            ? _c("modal", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("div", { staticStyle: { margin: "10px" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  padding: "0px !important",
                                  margin: "0px !important",
                                },
                              },
                              [
                                _c(
                                  "h3",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("Invite to Apply")]
                                ),
                                _c(
                                  "p",
                                  { staticStyle: { "margin-top": "10px" } },
                                  [
                                    _vm._v(
                                      "Invite (" +
                                        _vm._s(_vm.selected.length) +
                                        ") selected student(s) to apply for a job posting"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm.jobs.length !== 0
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "20px" } },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                            },
                                          },
                                          [_vm._v("Select Job Posting")]
                                        ),
                                        _c(
                                          "p",
                                          { staticStyle: { color: "red" } },
                                          [_vm._v(_vm._s(_vm.jobErrorMessage))]
                                        ),
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  placeholder: "Select a job",
                                                },
                                                model: {
                                                  value: _vm.selectedJob,
                                                  callback: function ($$v) {
                                                    _vm.selectedJob = $$v
                                                  },
                                                  expression: "selectedJob",
                                                },
                                              },
                                              _vm._l(_vm.jobs, function (job) {
                                                return _c(
                                                  "md-option",
                                                  {
                                                    key: job.jobId,
                                                    attrs: { value: job.name },
                                                  },
                                                  [_vm._v(_vm._s(job.name))]
                                                )
                                              }),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm.jobs.length === 0
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "20px" } },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "Before you can invite someone to apply, please post a job"
                                      ),
                                    ]),
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "jb-standard",
                                        on: { click: _vm.redirectToJobPost },
                                      },
                                      [_vm._v("Post a job")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "p",
                              { staticStyle: { "font-weight": "bold" } },
                              [
                                _vm._v(
                                  "Selected Student(s) (" +
                                    _vm._s(_vm.selected.length) +
                                    ")"
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "max-height": "250px",
                                  "overflow-y": "auto",
                                  "margin-bottom": "30px",
                                  "border-radius": "5px",
                                },
                              },
                              [
                                _c(
                                  "md-list",
                                  _vm._l(_vm.selected, function (item, index) {
                                    return _c(
                                      "md-list-item",
                                      { key: item.userId },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.selected[index].name +
                                                " " +
                                                _vm.selected[index].surname +
                                                " - " +
                                                _vm.selected[index]
                                                  .qualifications[0].degree
                                            ) +
                                            " "
                                        ),
                                        _c("md-divider", {
                                          staticClass: "md-inset",
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _vm.jobs.length !== 0
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "md-button",
                                    {
                                      staticClass: "md-danger",
                                      staticStyle: { "margin-right": "1rem" },
                                      on: { click: _vm.closeInvitationModal },
                                    },
                                    [_vm._v("Cancel")]
                                  ),
                                  _c(
                                    "md-button",
                                    {
                                      staticClass: "md-success",
                                      on: { click: _vm.sendJobInvitations },
                                    },
                                    [_vm._v("Send Invitations")]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "md-button",
                                    {
                                      staticClass: "md-success",
                                      on: {
                                        click: function ($event) {
                                          _vm.openInviteModal = _vm.fasle
                                        },
                                      },
                                    },
                                    [_vm._v("Ok")]
                                  ),
                                ],
                                1
                              ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3765053654
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.emailSent
        ? _c(
            "div",
            [
              _c("modal", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [_c("h3", [_vm._v("Success! 🥳")])]
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("div", [
                            _c("p", [
                              _vm._v("Email(s) have been successfully sent!"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.closeConfirmationModal()
                                },
                              },
                            },
                            [_vm._v("Ok")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  564139341
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.errorAuth
        ? _c(
            "div",
            [
              _c("modal", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("div", [_c("p", [_vm._v(_vm._s(_vm.authError))])]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "row",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-primary",
                                  staticStyle: {
                                    color: "white !important",
                                    "margin-right": "20px",
                                  },
                                  on: { click: _vm.promptLogin },
                                },
                                [_vm._v("Login")]
                              ),
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-danger",
                                  staticStyle: { color: "white !important" },
                                  on: {
                                    click: function ($event) {
                                      _vm.errorAuth = false
                                    },
                                  },
                                },
                                [_vm._v("Cancel")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  383485706
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("@/assets/img/logo.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }